import React from 'react';

const CustomerSummary = ({ customer }) => {
  if (!customer) return null;

  return (
    <div className="d-flex align-items-center gap-2">
      <span>
        {customer.name} {customer.surname}
      </span>
    </div>
  );
};

export default CustomerSummary;
